var map = {
	"./amber.jpg": "0cbc",
	"./guowei.jpg": "5a66",
	"./haidai.jpg": "97b5",
	"./jidy.jpg": "25f5",
	"./liumengyuan.jpg": "594f",
	"./ruantingting.jpg": "21ea",
	"./sujie.jpg": "a172",
	"./sumingxuan.jpg": "32b1",
	"./wangfangyu.jpg": "2479",
	"./wangjiadong.jpg": "02d5",
	"./yushuzhe.jpg": "126e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9bcc";